import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { isFirefox, isChrome } from 'react-device-detect';
import { nanoid } from 'nanoid';

// TODO keep improving ... not only File | Blob prints, etc

const cleanUpIframePrint = (params, objectUrl) => {
  const {
    onLoadingEnd,
    onPrintDialogClose
  } = params;

  // Check for a finished loading hook function
  onLoadingEnd && onLoadingEnd();
  if (objectUrl) URL.revokeObjectURL(objectUrl);

  // Run onPrintDialogClose callback
  let event = 'mouseover';
  if (isChrome || isFirefox) {
    // Ps.: Firefox will require an extra click in the document to fire the focus event.
    event = 'focus';
  }
  const handler = () => {
    // Make sure the event only happens once.
    window.removeEventListener(event, handler);
    onPrintDialogClose && onPrintDialogClose();

    // Remove iframe from the DOM
    const iframe = document.getElementById(params.frameId);
    if (iframe) {
      iframe.remove();
    }
  };
  window.addEventListener(event, handler);
};
const performIframePrint = (objectUrl, printFrame, params) => {
  const {
    onError
  } = params;
  try {
    var _printFrame$contentWi;
    printFrame.focus();
    (_printFrame$contentWi = printFrame.contentWindow) === null || _printFrame$contentWi === void 0 || _printFrame$contentWi.print();
  } catch (error) {
    onError && onError(error);
  } finally {
    if (isFirefox) {
      // Move the iframe element off-screen and make it invisible
      printFrame.style.visibility = 'hidden';
      printFrame.style.left = '-1px';
    }
    cleanUpIframePrint(params, objectUrl);
  }
};
const sendIframePrint = (data, printFrame, params) => {
  const objectUrl = URL.createObjectURL(data);
  printFrame.onload = () => {
    performIframePrint(objectUrl, printFrame, params);
  };
  printFrame.setAttribute('src', objectUrl);
  document.body.appendChild(printFrame);
};
export const printFile = data => {
  const params = {
    frameId: `print-iframe-${nanoid(8)}`
  };
  // To prevent duplication and issues, remove any used printFrame from the DOM
  const usedFrame = document.getElementById(params.frameId);
  if (usedFrame && usedFrame.parentNode) usedFrame.parentNode.removeChild(usedFrame);

  // Create a new iframe for the print job
  const printFrame = document.createElement('iframe');
  if (isFirefox) {
    // Set the iframe to be is visible on the page (guaranteed by fixed position) but hidden using opacity 0, because
    // this works in Firefox. The height needs to be sufficient for some part of the document other than the PDF
    // viewer's toolbar to be visible in the page
    printFrame.setAttribute('style', 'width: 1px; height: 100px; position: fixed; left: 0; top: 0; opacity: 0; border-width: 0; margin: 0; padding: 0');
  } else {
    // Hide the iframe in other browsers
    printFrame.setAttribute('style', 'visibility: hidden; height: 0; width: 0; position: absolute; border: 0');
  }
  printFrame.setAttribute('id', params.frameId);
  sendIframePrint(data, printFrame, params);
};